var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusBasedIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18C7.5398 18 3.5 13.9602 3.5 9C3.5 4.0398 7.5398 0 12.5 0C14.5398 0 16.5398 0.7 18.1204 1.97968C18.4602 2.25936 18.5204 2.75936 18.2407 3.1C17.961 3.43984 17.461 3.5 17.1204 3.22031C15.8001 2.16015 14.2 1.59999 12.5 1.59999C8.42039 1.59999 5.09999 4.92039 5.09999 8.99999C5.09999 13.0796 8.42039 16.4 12.5 16.4C12.9398 16.4 13.3 16.7602 13.3 17.2C13.3 17.6398 12.9398 18 12.5 18ZM15.7 17.3602C15.3797 17.3602 15.1 17.1805 14.9602 16.8805C14.7805 16.4805 14.9805 16.0008 15.3805 15.8406C18.1203 14.6602 19.9001 11.9796 19.9001 9.00004C19.9001 8.5602 20.2602 8.20004 20.7001 8.20004C21.1399 8.20004 21.5001 8.5602 21.5001 9.00004C21.5001 12.6204 19.3399 15.8796 16.0205 17.2796C15.9205 17.3398 15.8 17.3602 15.7 17.3602Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.2008C9.63985 14.2008 7.30005 11.861 7.30005 9.00078C7.30005 6.14058 9.63985 3.80078 12.5 3.80078C13.6204 3.80078 14.6796 4.14062 15.5796 4.80078C15.9398 5.06094 16.0195 5.56094 15.7593 5.9211C15.4992 6.28126 14.9992 6.36094 14.639 6.10079C14 5.64063 13.2796 5.40079 12.5 5.40079C10.5203 5.40079 8.90002 7.02111 8.90002 9.00079C8.90002 10.9805 10.5203 12.6008 12.5 12.6008C14.4797 12.6008 16.1 10.9805 16.1 9.00079C16.1 8.56095 16.4602 8.20079 16.9 8.20079C17.3399 8.20079 17.7 8.56095 17.7 9.00079C17.7 11.861 15.3602 14.2008 12.5 14.2008Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusBasedIc);
export default __webpack_public_path__ + "static/media/status_based_ic.355f4008b9e02a41c8e39ff14f55755f.svg";
export { ForwardRef as ReactComponent };